import { LifeCycle } from "./types";
const EMPTY = {};
const noop = () => {
};
class SlardarContainer {
  create(prefix) {
    const container = new SlardarContainer(prefix);
    const slardarInstance = this._instance.create(container._prefix);
    container._inject(slardarInstance);
    container._setConfigInjector(this._configInjector);
    container._callSyncHook(this._plugins, {
      prefix
    }, LifeCycle.OnCreate, ({ returnValue }) => {
      container._plugins.push(returnValue);
    });
    container._callSyncHook(container._plugins, container._extends, LifeCycle.OnConnect);
    return container;
  }
  setGlobalSlardarName(name) {
    this._instance.setGlobalSlardarName?.(name);
  }
  _inject(instance) {
    this._instance = instance;
    this._injected = true;
  }
  _setConfigInjector(injector) {
    this._configInjector = injector;
  }
  assertInjected() {
    if (!this._injected)
      throw Error("[Slardar] instance has not injected into container");
  }
  init(config) {
    const injectedOpts = this._configInjector();
    void this._doInit({
      ...injectedOpts,
      ...config
    });
  }
  async _doInit(config) {
    if (this._inited)
      return;
    this.assertInjected();
    const Slardar = this._instance;
    Slardar.context(config.context);
    Slardar.init(config);
    this._inited = true;
    await this._callAsyncHook(this._plugins, config, LifeCycle.OnInit);
    if (config.autoStart)
      this.start();
  }
  config(opts) {
    return this._instance.config(opts);
  }
  context(args) {
    this._instance.context(args);
  }
  start() {
    this._instance.start();
  }
  captureException(error, extra, react) {
    this._instance.captureException(error, extra, react);
  }
  sendEvent(data) {
    this._instance.sendEvent(data);
  }
  sendLog(data) {
    this._instance.sendLog(data);
  }
  sendCustomPerfMetric(data) {
    this._instance.sendCustomPerfMetric(data);
  }
  sendPageview(pid) {
    return this._instance.sendPageview?.(pid);
  }
  on(ev, cb) {
    this._instance.on(ev, cb);
  }
  rawInstance() {
    return this._instance.rawInstance();
  }
  use(plugin) {
    this._plugins.push(plugin);
    this._callSyncHook([
      plugin
    ], this._extends, LifeCycle.OnConnect);
  }
  _callSyncHook(plugins, data, hook, cb = noop) {
    plugins.forEach((plugin, index) => {
      const listener = plugin[hook];
      if (listener) {
        const returnValue = listener.call(plugin, {
          data,
          container: this
        });
        cb({
          plugin,
          index,
          returnValue
        });
      }
    });
  }
  _callAsyncHook(plugins, data, hook) {
    const pluginPromises = [];
    plugins.forEach((plugin) => {
      const listener = plugin[hook];
      if (listener) {
        const maybePromise = listener.call(plugin, {
          data,
          container: this
        });
        if (maybePromise && "then" in maybePromise) {
          pluginPromises.push(maybePromise);
        }
      }
    });
    return Promise.all(pluginPromises).catch((e) => console.error(e));
  }
  reportActualFMP() {
    const time = this.ttap.reportActualFMP?.();
    this.sparkTracing?.reportActualFMP();
    return time ?? 0;
  }
  /** ttap funcs start */
  // ttap funs and object will inject by TtapPlugin
  // there are stub
  /**
  * @deprecated use `Slardar.reportActualFMP()` instead.
  */
  reportActualLCP() {
    throw Error("not implement");
  }
  reportCustomRequest(requestName, startTime, endTime) {
    throw Error("not implement");
  }
  getContainerInitTotalTime() {
    throw Error("not implement");
  }
  reportFirstScreenRequest(startTimestamp, endTimestamp) {
    throw Error("not implement");
  }
  reportRenderStart() {
    throw Error("not implement");
  }
  reportRenderEnd() {
    throw Error("not implement");
  }
  constructor(prefix = "global") {
    this._instance = EMPTY;
    this._injected = false;
    this._plugins = [];
    this._configInjector = () => null;
    this._inited = false;
    this._extends = (name, obj) => {
      this[name] = obj;
    };
    this.ttap = {};
    this._prefix = prefix;
  }
}
export {
  SlardarContainer
};

//# sourceMappingURL=container.js.map